export default __webpack_public_path__ + "static/media/survey.cb7cd2fa.png";